import { __module as r } from "../../../../../../_virtual/index2.js";
import { __require as o } from "../cjs/use-sync-external-store-shim.production.js";
import { __require as i } from "../cjs/use-sync-external-store-shim.development.js";
var e;
function u() {
  return e ? r.exports : (e = 1, process.env.NODE_ENV === "production" ? r.exports = o() : r.exports = i(), r.exports);
}
export {
  u as __require
};
//# sourceMappingURL=index.js.map
